import { useEffect, useState } from 'react';
import { Box, Typography, Container, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Grid, RadioGroup, FormControlLabel, Radio, FormControl, FormLabel, Checkbox, FormGroup, FormHelperText } from '@mui/material';
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from './api.js';
import Header from './components/Header.jsx';
import { useConfirmBackLogout } from './common/useConfirmBackLogout.js';
import BackButton from './common/BackButton.js';
import { useNavigationHistory } from "./common/navigationHistory.js";
import { useValidatedChangeWithError } from './common/useValidatedChangeWithError.js';
import { useValidatedDetailChangeByKey } from './common/useValidatedDetailChangeByKey.js';
import { decimalValidator, intValidator } from './common/validators.js';
import HamburgerMenu from './components/Hamburger.jsx';

const Comp5Sub = ({exhibitorId: propExhibitorId, isModal=false, setFormModalOpen, isCorpModal=false, selectedFormKey, changeModalOpen, setExhibitors, conRepId}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [sameAsExhibitoro5, setSameAsExhibitoro5] = useState("different");
  const [sameAsInvoice5, setSameAsInvoice5] = useState("different");
  const create100Detail = () => ({
    device_100_name: '',
    quantity_100: 0,
    number_100: 0,
    total_100: 0,
    ex_100: ''
  });
  const create200Detail = () => ({
    device_200_name: '',
    quantity_200: 0,
    number_200: 0,
    total_200: 0,
    ex_200: ''
  });
  const [comp5Data, setComp5Data] = useState({
    user_5_name: "",
    user_5_department: "",
    user_5_phone: "",
    user_5_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    elec_select: false,
    elec_company_name: "",
    elec_address: "",
    elec_zip: "",
    elec_user_name: "",
    elec_tel: "",
    elec_fax: "",
    quantity_100v: false,
    quantity_200v: false,
    quantity_all: 0,
    alfa_text: "",
    ordi_elec: false,
    details_100: [
      create100Detail()
    ],
    details_200: [
      create200Detail()
    ]
  });

  const [checked, setChecked] = useState({
      v100: false,
      v200: false,
  });

  const [detailErrors, setDetailErrors] = useState({
    details_100: [],
    details_200: [],
  });

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };

   const handleCorrection = async () => {
    try {
      const res = await api.patch('/api/forms/correction', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        corporate_type: conRepId,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'correction');

      alert('再提出に更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('再提出処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      corporate_type: conRepId,
        role: "corporate"
    });
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        corporate_type: conRepId,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'confirm');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      corporate_type: conRepId,
        role: "corporate"
    });
  };

  useEffect(() => {
    const init = async () => {
      // 1. propExhibitorId 優先
      if ((isModal || isCorpModal) && propExhibitorId) {
        setExhibitorId(propExhibitorId);
        return;
      }

      // 2. localStorage 優先
      const userData = localStorage.getItem("user");
      if (userData) {
        const parsedUser = JSON.parse(userData);
        if (parsedUser?.exhibitor_id) {
          setExhibitorId(parsedUser.exhibitor_id);
          return;
        }
      }

      // 3. localStorage ない場合 → APIから再取得
      try {
        const res = await api.get("/api/auth/me"); // ←要: サーバー側で実装
        if (res.data?.exhibitor_id) {
          setExhibitorId(res.data.exhibitor_id);
          localStorage.setItem("user", JSON.stringify(res.data));
        } else {
          console.warn("exhibitor_id が取得できません");
        }
      } catch (err) {
        console.error("ユーザー再取得エラー:", err);
      }
    };

    init();
  }, [location, isModal, isCorpModal, propExhibitorId]);

  const [notApply5, setNotApply5] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [isHovered, setIsHovered] = useState(false);

  const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
      { label: '小間図面', path: '/小間図面.pdf' },
      { label: '素材集', path: '/素材集.zip' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];

  const renderMenuItems = () => (
    <div
        className="menu-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
    >
        <div className="menu-label">資料ダウンロード</div>
        {isHovered && (
        <div className="submenu">
            {pdfItems.map((item, index) => (
            <a key={index} href={item.path} download className="submenu-item">
                {item.label}
            </a>
            ))}
        </div>
        )}
    </div>
  );

  const [noticeModalOpen, setNoticeModalOpen] = useState(false);
  const [ submitErrors5, setSubmitErrors5] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setComp5Data({ ...comp5Data, [name]: type === 'checkbox' ? checked : value });
  };
    const handleDetailValidatedChange =
    useValidatedDetailChangeByKey(setComp5Data, setDetailErrors);

    useEffect(() => {
      setComp5Data((prev) => {
        let changed = false;

        const new100 = prev.details_100.map((row) => {
          const q = Number(row.quantity_100) || 0;
          const n = Number(row.number_100) || 0;
          const total = q * n;

          if (row.total_100 !== total) changed = true;

          return { ...row, total_100: total };
        });

        const new200 = prev.details_200.map((row) => {
          const q = Number(row.quantity_200) || 0;
          const n = Number(row.number_200) || 0;
          const total = q * n;

          if (row.total_200 !== total) changed = true;

          return { ...row, total_200: total };
        });

        const sum100 = new100.reduce((sum, r) => sum + (r.total_100 || 0), 0);
        const sum200 = new200.reduce((sum, r) => sum + (r.total_200 || 0), 0);

        const quantity_all = sum100 + sum200;

        if (prev.quantity_all !== quantity_all) changed = true;

        if (!changed) return prev;

        return {
          ...prev,
          details_100: new100,
          details_200: new200,
          quantity_all,
        };
      });
    }, [comp5Data.details_100, comp5Data.details_200]);

  // const handleQuantityChange = (field, value) => {
  //   let errorMsg = "";

  //   if (value === "" || /^[0-9]+$/.test(value)) {
  //       const numericValue = value === "" ? "" : Number(value);
  //       const newForm = { ...comp5Data, [field]: numericValue };

  //       const all100 =
  //       newForm.details_100?.reduce((sum, r) => sum + (Number(r.total_100) || 0), 0) || 0;
  //       const all200 =
  //       newForm.details_200?.reduce((sum, r) => sum + (Number(r.total_200) || 0), 0) || 0;

  //       const quantity100v = Number(newForm.quantity_100v) || 0;
  //       const quantity200v = Number(newForm.quantity_200v) || 0;

  //       newForm.quantity_all = quantity100v + quantity200v + all100 + all200;

  //       setComp5Data(newForm);
  //   } else {
  //       errorMsg = "半角数字（整数）のみ入力してください";
  //   }

  //   // エラー保存
  //   setSubmitErrors5((prev) => ({
  //       ...prev,
  //       [field]: errorMsg,
  //   }));
  //   };

    const normalizeO5Data = (raw) => ({
        ...raw,
        details_100: Array.isArray(raw.details_100) ? raw.details_100 : [],
        details_200: Array.isArray(raw.details_200) ? raw.details_200 : [],
    });

    const user = JSON.parse(localStorage.getItem("user"));

    const [fieldsDisabled, setFieldsDisabled] = useState(false);
    const [invFieldsDisabled, setInvFieldsDisabled] = useState(false);

    
    const handleCheckboxChange = (e) => {
      const { name, checked: isChecked } = e.target;

      setChecked((prev) => ({ ...prev, [name]: isChecked }));

      if (name === "v100") {
          setComp5Data((prev) => ({
              ...prev,
              details_100: isChecked
                  ? (prev.details_100.length ? prev.details_100 : [create100Detail])
                  : [],
          }));
      }

      if (name === "v200") {
          setComp5Data((prev) => ({
              ...prev,
              details_200: isChecked
                  ? (prev.details_200.length ? prev.details_200 : [create200Detail])
                  : [],
          }));
      }
  };

    useEffect(() => {
      if (!comp5Data.ordi_elec) {

        // 追加電気容量チェックOFF
        setChecked({
          v100: false,
          v200: false,
        });

        // comp5Data内部リセット
        setComp5Data((prev) => ({
          ...prev,
          details_100: [],
          details_200: []
        }));
      }
    }, [comp5Data.ordi_elec]);

    useEffect(() => {
        const fetchComp5Data = async () => {
            setLoading(true);
            try {
                const [resData, resStatus, resMypage] = await Promise.all([
                    api.get(`/api/forms/o5/${exhibitorId}`),
                    api.get(`/api/submission-status/${exhibitorId}`),
                    api.get(`/api/mypage/${exhibitorId}`)
                ]);

                const o5Raw = resData.data.o5 || {};
                console.log("details_100", o5Raw.details_100);
                console.log("details_200", o5Raw.details_200);
                const status = resStatus.data?.o5_status || "";
                const mypage = resMypage.data || {};

                setChecked({
                    v100: Array.isArray(o5Raw.details_100)
                        ? o5Raw.details_100.length > 0
                        : false,

                    v200: Array.isArray(o5Raw.details_200)
                        ? o5Raw.details_200.length > 0
                        : false,
                });

                // notApply5 状態
                if (status === "申請しない") {
                    setNotApply5(true);
                    setFieldsDisabled(false);
                    setInvFieldsDisabled(false);
                } else {
                    // データがあるかチェック
                    if (Object.values(o5Raw).some(v => {
                        if (Array.isArray(v)) return v.length > 0;
                        return v !== "" && v !== null && v !== undefined;
                    })) {
                        setComp5Data(prev => ({
                            ...prev,
                            ...normalizeO5Data(o5Raw),
                        }));

                        // mypage と一致してるか判定
                        if (
                            o5Raw.user_5_name === mypage.user_name &&
                            o5Raw.user_5_department === mypage.department &&
                            o5Raw.user_5_phone === mypage.phone_number &&
                            o5Raw.user_5_tel === mypage.tel_number
                        ) {
                            setSameAsExhibitoro5("same");
                            setFieldsDisabled(true);
                        } else {
                            setFieldsDisabled(false);
                        }
                        if (
                            o5Raw.invoice_company_name === mypage.company_name &&
                            o5Raw.invoice_user_name === mypage.user_name &&
                            o5Raw.invoice_email === mypage.email &&
                            o5Raw.invoice_address === mypage.address &&
                            o5Raw.invoice_tel === mypage.phone_number &&
                            o5Raw.invoice_zip === mypage.zip_code
                        ) {
                            setSameAsInvoice5("same");
                            setInvFieldsDisabled(true);
                        } else {
                            setInvFieldsDisabled(false);
                        }
                    } else {
                        // データが空ならとりあえずフォームは編集可
                        setComp5Data(normalizeO5Data(o5Raw));
                        setFieldsDisabled(false);
                        setInvFieldsDisabled(false);
                    }

                    setNotApply5(false);
                }
            } catch (err) {
                console.error("Comp5 初期化エラー:", err);
            } finally {
                setLoading(false);
            }
        };

        if (exhibitorId) {
            fetchComp5Data();
        }
    }, [exhibitorId]);

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitoro5(value);

    if (value === "same") {
        // 出展者情報コピー
        setComp5Data((prev) => ({
        ...prev,
        user_5_name: mypageData.user_name || "",
        user_5_department: mypageData.department || "",
        user_5_phone: mypageData.phone_number || "",
        user_5_tel: mypageData.tel_number || "",
        }));
        setFieldsDisabled(true);
    } else if (value === "different") {
        // フィールドを空にする
        setComp5Data((prev) => ({
        ...prev,
        user_5_name: "",
        user_5_department: "",
        user_5_phone: "",
        user_5_tel: "",
        }));
        setFieldsDisabled(false);
    }
  };

  const handleSameAsInvoice = (value) => {
    setSameAsInvoice5(value);

    if (value === "same") {
      setComp5Data((prev) => ({
        ...prev,
        invoice_company_name: mypageData.company_name || "",
        invoice_user_name: mypageData.user_name || "",
        invoice_email: mypageData.email || "",
        invoice_address: mypageData.address || "",
        invoice_zip: mypageData.zip_code || "",
        invoice_tel: mypageData.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } else if (value === "different") {
      setComp5Data((prev) => ({
        ...prev,
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
      }));
      setInvFieldsDisabled(false);
    }
  };

  const handleNoApplyChange = (checkedValue) => {
    setNotApply5(checkedValue);

    if (checkedValue) {
        setComp5Data({
        user_5_name: null,
        user_5_department: null,
        user_5_phone: null,
        user_5_tel: null,
        invoice_company_name: null,
        invoice_user_name: null,
        invoice_email: null,
        invoice_address: null,
        invoice_zip: null,
        invoice_tel: null,
        invoice_fax: null,
        elec_select: null,
        elec_company_name: null,
        elec_address: null,
        elec_zip: null,
        elec_user_name: null,
        elec_tel: null,
        elec_fax: null,
        quantity_100v: null,
        quantity_200v: null,
        quantity_all: null,
        alfa_text: null,
        ordi_elec: null,
        details_100: [],
        details_200: []
        });

        // チェックボックスの状態もリセット
        setChecked({
        v100: false,
        v200: false
        });
    }
    };

  const getEmptyDetailRow = (key) => {
    if (key === "details_100") {
        return {
        device_100_name: "",
        quantity_100: 0,
        number_100: 0,
        total_100: 0,
        ex_100: "",
        };
    } else if (key === "details_200") {
        return {
        device_200_name: "",
        quantity_200: 0,
        number_200: 0,
        total_200: 0,
        ex_200: "",
        };
    }
    return {};
    };

    const addDetail = (key) => {
    const newDetail = getEmptyDetailRow(key);
    setComp5Data((prev) => ({
        ...prev,
        [key]: [...(prev[key] || []), newDetail],
    }));
    };

    // 共通化された削除関数
    const removeDetail = (key, index) => {
    const newDetails = comp5Data[key].filter((_, i) => i !== index);
    setComp5Data((prev) => ({
        ...prev,
        [key]: newDetails,
    }));
    };

    // 共通化された合計計算関数
    const recalcTotals = (form) => {
      const calcDetailsTotal = (details, key) => {
        if (!Array.isArray(details)) return 0;
        return details.reduce((sum, r) => sum + (Number(r[key]) || 0), 0);
      };

      const all100 = calcDetailsTotal(form.details_100, "total_100");
      const all200 = calcDetailsTotal(form.details_200, "total_200");

      return {
        ...form,
        quantity_all: all100 + all200
      };
    };
    // 入力処理
    const handleDetailChange = (field, index, key, value) => {
        const newDetails = [...comp5Data[field]];
        let errorMsg = "";

        // 整数入力チェック
        if (["quantity_100", "number_100", "quantity_200", "number_200"].includes(key)) {
            if (value === "" || /^[0-9]+$/.test(value)) {
                // OK → 数値に変換（空文字はそのまま）
                newDetails[index] = { 
                    ...newDetails[index], 
                    [key]: value === "" ? "" : Number(value) 
                };
            } else {
                // NG → 値はそのまま保持
                newDetails[index] = { 
                    ...newDetails[index], 
                    [key]: value 
                };
                errorMsg = "半角数字（整数）のみ入力してください";
            }
        } else {
            // 他のフィールドはそのまま反映
            newDetails[index] = { ...newDetails[index], [key]: value };
        }

        // total計算
        if (field === "details_200" && (key === "quantity_200" || key === "number_200")) {
            const quantity = Number(newDetails[index].quantity_200) || 0;
            const number = Number(newDetails[index].number_200) || 0;
            newDetails[index].total_200 = quantity * number;
        }
        if (field === "details_100" && (key === "quantity_100" || key === "number_100")) {
            const quantity = Number(newDetails[index].quantity_100) || 0;
            const number = Number(newDetails[index].number_100) || 0;
            newDetails[index].total_100 = quantity * number;
        }

        // フォームのコピーを作成して更新
        const newForm = recalcTotals({ ...comp5Data, [field]: newDetails });
        setComp5Data(newForm);

        // 合計計算関数
        const calcDetailsTotal = (details, key) => {
            if (!Array.isArray(details)) return 0;
            return details.reduce((sum, r) => sum + (Number(r[key]) || 0), 0);
        };

        const all100 = calcDetailsTotal(newForm.details_100, "total_100");
        const all200 = calcDetailsTotal(newForm.details_200, "total_200");

        newForm.quantity_all = all100 + all200;

        // state更新
        setComp5Data(newForm);

        // エラー保存（キーはユニーク化する）
        setSubmitErrors5((prev) => ({
            ...prev,
            [`${field}_${index}_${key}`]: errorMsg,
        }));
    };

  const handleParentInvoiceClick = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/parent-invoice/${mypageData.representative_id}`);
      const data = res.data;
      setComp5Data((prev) => ({
        ...prev,
        invoice_company_name: data.company_name || "",
        invoice_user_name: data.user_name || "",
        invoice_email: data.email || "",
        invoice_address: data.address || "",
        invoice_zip: data.zip_code || "",
        invoice_tel: data.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } catch (error) {
      console.error("親出展者の請求情報取得に失敗しました:", error);
      alert("親出展者の情報を取得できませんでした。");
    } finally {
      setLoading(false);
    }
  };
  

  const handleSubmit = async () => {
    try {
      if (!exhibitorId || typeof exhibitorId !== "number") {
        console.error("exhibitorId が不正やで:", exhibitorId);
        alert("exhibitorId が不正です");
        return;
      }

      // === Comp5Sub バリデーション ===
      const submitErrors5 = {};
      if (!notApply5) {
        if (!comp5Data.user_5_name?.trim()) submitErrors5.user_5_name = "入力してください";
        if (!comp5Data.user_5_department?.trim()) submitErrors5.user_5_department = "入力してください";
        if (!comp5Data.user_5_phone?.trim()) submitErrors5.user_5_phone = "入力してください";
        if (!comp5Data.user_5_tel?.trim()) submitErrors5.user_5_tel = "入力してください";
        if (!comp5Data.invoice_company_name?.trim()) submitErrors5.invoice_company_name = "入力してください";
        if (!comp5Data.invoice_user_name?.trim()) submitErrors5.invoice_user_name = "入力してください";
        if (!comp5Data.invoice_email?.trim()) submitErrors5.invoice_email = "入力してください";
        if (!comp5Data.invoice_address?.trim()) submitErrors5.invoice_address = "入力してください";
        if (!comp5Data.invoice_zip?.trim()) submitErrors5.invoice_zip = "入力してください";
        if (!comp5Data.invoice_tel?.trim()) submitErrors5.invoice_tel = "入力してください";

        // 電気工事業者情報
        if (comp5Data.elec_select) {
          const requiredFields = [
            "elec_company_name",
            "elec_zip",
            "elec_address",
            "elec_user_name",
            "elec_tel",
            "elec_fax"
          ];
          requiredFields.forEach((field) => {
            if (!comp5Data[field] || comp5Data[field].trim() === "") {
              submitErrors5[field] = "必須入力です";
            }
          });
        }

        // 必要電気容量
        // if (!checked?.v100 && !checked?.v200) {
        //   submitErrors5.elec_check = "100Vか200Vのいずれかを選択してください";
        // }

        // 100V詳細
        if (checked?.v100) {
          comp5Data.details_100.forEach((d, i) => {
            if (d.quantity_100 > 0 && !d.number_100) {
              submitErrors5[`details_100_${i}_number`] = "数量を入力してください";
            }
          });
        }

        // 200V詳細
        if (checked?.v200) {
          comp5Data.details_200.forEach((d, i) => {
            if (d.quantity_200 > 0 && !d.number_200) {
              submitErrors5[`details_200_${i}_number`] = "数量を入力してください";
            }
          });
        }
      }

      // === エラーがあれば表示して中止 ===
      if (Object.keys(submitErrors5).length > 0) {
        setSubmitErrors5(submitErrors5);
        window.scrollTo({ top: 0, behavior: "smooth" });

        const fieldDisplayNames = {
          user_5_name: "担当者名",
          user_5_department: "担当部署",
          user_5_phone: "担当者携帯",
          user_5_tel: "担当者電話",
          invoice_company_name: "請求先会社名",
          invoice_user_name: "請求先担当者名",
          invoice_email: "請求先メールアドレス",
          invoice_address: "請求先住所",
          invoice_zip: "請求先郵便番号",
          invoice_tel: "請求先電話番号",
          elec_select: "電気工事委託 有無選択",
          elec_company_name: "電気工事委託 会社名",
          elec_zip: "電気工事委託 郵便番号",
          elec_address: "電気工事委託 住所",
          elec_user_name: "電気工事委託 担当者名",
          elec_tel: "電気工事委託 電話番号",
          elec_fax: "電気工事委託 FAX番号",
          elec_check: "必要電気容量",
          quantity_100v: "100V 終夜送電",
          quantity_200v: "200V 終夜送電",
          details_100: "100V 機器詳細",
          details_200: "200V 機器詳細",
          details_100_name: "100V 機器名",
          details_100_quantity: "100V 容量",
          details_100_number: "100V 台数",
          details_200_name: "200V 機器名",
          details_200_quantity: "200V 容量",
          details_200_number: "200V 台数",
        };

        const errorMessages = Object.entries(submitErrors5)
          .map(([key, msg]) => {
            const baseKey = key.replace(/_\d+_.*/, "");
            return `・${fieldDisplayNames[key] || fieldDisplayNames[baseKey] || key}：${msg}`;
          })
          .join("\n");

        alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
        return;
      }

      // === not apply データ ===
      const noAp5Data = {
        user_5_name: "",
        user_5_department: "",
        user_5_phone: "",
        user_5_tel: "",
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
        invoice_fax: "",
        elec_select: null,
        elec_company_name: null,
        elec_address: null,
        elec_zip: null,
        elec_user_name: null,
        elec_tel: null,
        elec_fax: null,
        quantity_100v: null,
        quantity_200v: null,
        quantity_all: null,
        alfa_text: null,
        ordi_elec: null,
        details_100: [],
        details_200: []
      };

      // === サニタイズ関数 ===
      const sanitizeDetails = (details, type) => {
        if (!Array.isArray(details)) return [];
        return details
          .filter(d => {
            if (type === "100") return d.quantity_100 > 0 && d.number_100 > 0;
            if (type === "200") return d.quantity_200 > 0 && d.number_200 > 0;
            return d.elec_item_id && d.number > 0; // comp6
          })
          .map(d => ({ ...d }));
      };

      const sanitizeComp5Data = (data) => {
        let newData = { ...data };
        // elec_select サニタイズ
        if (newData.elec_select === null) {
          if (notApply5) {
            newData.elec_select = null; // そのまま
          } else if (!newData.elec_company_name || newData.elec_company_name.trim() === "") {
            newData.elec_select = true;
          } else {
            newData.elec_select = false;
          }
        }

        return newData;
      };

      // === データ整形 ===
      const sanitizedComp5 = sanitizeComp5Data(comp5Data);
      sanitizedComp5.details_100 = sanitizeDetails(sanitizedComp5.details_100, "100");
      sanitizedComp5.details_200 = sanitizeDetails(sanitizedComp5.details_200, "200");

      const payload = {
        exhibitor_id: exhibitorId,
        notApply5,
        o5: notApply5 ? noAp5Data : sanitizedComp5,
      };

      console.log(payload);

      const res = await api.post("/api/o5-submit", payload);
      if (res.status === 200) {
        setNoticeModalOpen(true);
        alert("保存成功");
      } else {
        alert("保存失敗");
      }
    } catch (err) {
      console.error(err);
      alert("エラー");
    }
  };

  const handleCloseNotice = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    setNoticeModalOpen(false);
    setTimeout(() => {
      if (isModal) {
        setFormModalOpen(false);
      } else {
        if (user?.user_id === 0) {
          navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
        } else {
          navigate(`/mypage/${user?.mypage_id}`);
        }
      }
    }, 1000);
  };

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="SDGs 子ども・ユースフェア2026 電気使用申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }} className='sm-block'>
        {!isCorpModal &&(
        <>
        <Container sx={{ width: '22%', mt: 4 }} className='sm-none'>
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0071BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#0071bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Box sx={{ position: 'fixed', width: '14%' }}>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
            <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', margin: 'auto'}}>電気(電力)使用申込</Typography>
            <Container sx={{width: '95%', margin: 'auto', border: '1px solid #000', borderRadius: '12px'}}>
                <Box sx={{ p: 2 }}>
                    <FormControlLabel
                    control={<Checkbox checked={notApply5} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
                    label="申請しない"
                    />
                    {!notApply5 && (
                    <Box>
                        <Typography variant="h6" gutterBottom>担当者情報</Typography>
                        <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                        <FormControl component="fieldset" sx={{ mt: 2 }}>
                            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                            <RadioGroup
                            row
                            value={sameAsExhibitoro5}
                            onChange={(e) => handleSameAsExhibitor(e.target.value)}
                            >
                            <FormControlLabel value="same" control={<Radio />} label="同じ" />
                            <FormControlLabel value="different" control={<Radio />} label="異なる" />
                            </RadioGroup>
                        </FormControl>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="氏名" name="user_5_name" value={comp5Data.user_5_name} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors5.user_5_name} helperText={submitErrors5.user_5_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="部署" name="user_5_department" value={comp5Data.user_5_department} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors5.user_5_department} helperText={submitErrors5.user_5_department} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="会社電話番号" name="user_5_phone" value={comp5Data.user_5_phone} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors5.user_5_phone} helperText={submitErrors5.user_5_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="携帯電話番号" name="user_5_tel" value={comp5Data.user_5_tel} onChange={handleChange} disabled={fieldsDisabled} error={!!submitErrors5.user_5_tel} helperText={submitErrors5.user_5_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                        </Grid>
                        <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

                        <Typography variant="h6" gutterBottom>
                        請求先情報
                        </Typography>
                        <FormControl component="fieldset">
                        <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                        <RadioGroup row value={sameAsInvoice5} onChange={(e) => handleSameAsInvoice(e.target.value)}>
                            <FormControlLabel value="same" control={<Radio />} label="同じ" />
                            <FormControlLabel value="different" control={<Radio />} label="異なる" />
                        </RadioGroup>
                        {user?.co_exhibit && sameAsInvoice5 === "different" && (
                            <Button
                            variant="outlined"
                            onClick={handleParentInvoiceClick}
                            disabled={loading}
                            style={{ marginBottom: "16px" }}
                            >
                            親出展者に請求する
                            </Button>
                        )}
                        </FormControl>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求先会社名" value={comp5Data.invoice_company_name} onChange={(e) => setComp5Data({ ...comp5Data, invoice_company_name: e.target.value })} disabled={invFieldsDisabled} error={!!submitErrors5.invoice_company_name} helperText={submitErrors5.invoice_company_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求担当者名" value={comp5Data.invoice_user_name} onChange={(e) => setComp5Data({ ...comp5Data, invoice_user_name: e.target.value })} disabled={invFieldsDisabled} error={!!submitErrors5.invoice_user_name} helperText={submitErrors5.invoice_user_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                            <Grid size={12}><TextField fullWidth label="請求先メールアドレス" value={comp5Data.invoice_email} onChange={(e) => setComp5Data({ ...comp5Data, invoice_email: e.target.value })} disabled={invFieldsDisabled} error={!!submitErrors5.invoice_email} helperText={submitErrors5.invoice_email} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                            <Grid size={6}><TextField fullWidth label="郵便番号" value={comp5Data.invoice_zip} onChange={(e) => setComp5Data({ ...comp5Data, invoice_zip: e.target.value })} disabled={invFieldsDisabled} error={!!submitErrors5.invoice_zip} helperText={submitErrors5.invoice_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                            <Grid size={12}><TextField fullWidth label="請求先住所" value={comp5Data.invoice_address} onChange={(e) => setComp5Data({ ...comp5Data, invoice_address: e.target.value })} disabled={invFieldsDisabled} error={!!submitErrors5.invoice_address} helperText={submitErrors5.invoice_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                            <Grid size={6}><TextField fullWidth label="電話番号" value={comp5Data.invoice_tel} onChange={(e) => setComp5Data({ ...comp5Data, invoice_tel: e.target.value })} disabled={invFieldsDisabled} error={!!submitErrors5.invoice_tel} helperText={submitErrors5.invoice_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                            <Grid size={6}><TextField fullWidth label="FAX番号" value={comp5Data.invoice_fax} onChange={(e) => setComp5Data({ ...comp5Data, invoice_fax: e.target.value })} disabled={invFieldsDisabled} /></Grid>
                        </Grid>

                        <Typography variant="h6" sx={{ mt: 4 }}>小間内電気工事</Typography>
                        <Grid container spacing={2}>
                            <FormControl component="fieldset">
                            <FormLabel component="legend">自社で依頼している電気工事の委託業者がありますか？</FormLabel>
                            <RadioGroup
                            row
                            value={comp5Data.elec_select === true ? 'true' : 'false'}
                            onChange={(e) =>
                                setComp5Data({ ...comp5Data, elec_select: e.target.value === 'true' })
                            }
                            >
                            <FormControlLabel value="true" control={<Radio />} label="ある" />
                            <FormControlLabel value="false" control={<Radio />} label="ない" />
                            </RadioGroup>
                            </FormControl>

                            {/* falseのときのみ表示 */}
                            {comp5Data.elec_select && (
                            <>
                            <Typography>自社で依頼している電気工事の委託会社情報をご入力ください。</Typography>
                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    fullWidth
                                    label="業者名"
                                    name="elec_company_name"
                                    value={comp5Data.elec_company_name}
                                    onChange={handleChange}
                                    error={!!submitErrors5.elec_company_name}
                                    helperText={submitErrors5.elec_company_name}
                                    slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                                />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    fullWidth
                                    label="郵便番号"
                                    name="elec_zip"
                                    value={comp5Data.elec_zip}
                                    onChange={handleChange}
                                    error={!!submitErrors5.elec_zip}
                                    helperText={submitErrors5.elec_zip}
                                    slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                                />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    fullWidth
                                    label="住所"
                                    name="elec_address"
                                    value={comp5Data.elec_address}
                                    onChange={handleChange}
                                    error={!!submitErrors5.elec_address}
                                    helperText={submitErrors5.elec_address}
                                    slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                                />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    fullWidth
                                    label="担当者名"
                                    name="elec_user_name"
                                    value={comp5Data.elec_user_name}
                                    onChange={handleChange}
                                    error={!!submitErrors5.elec_user_name}
                                    helperText={submitErrors5.elec_user_name}
                                    slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                                />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    fullWidth
                                    label="電話番号"
                                    name="elec_tel"
                                    value={comp5Data.elec_tel}
                                    onChange={handleChange}
                                    error={!!submitErrors5.elec_tel}
                                    helperText={submitErrors5.elec_tel}
                                    slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                                />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    fullWidth
                                    label="FAX番号"
                                    name="elec_fax"
                                    value={comp5Data.elec_fax}
                                    onChange={handleChange}
                                />
                                </Grid>
                            </Grid>
                            </>
                            )}
                        </Grid>

                        <Typography color='error'>
                            【注意】<br />
                            ※1つのコンセントにて取り出せる電力は1.5kWまでとなります。2.0kW以上の追加容量をお申込みの出展者は、必要に応じて電気備品レンタル申込にてコンセントをお申し込みください。<br />
                            ※レイアウト（ブレーカー位置・コンセント位置）は「ブース平面図」より必ずご提出ください。<br />
                            ※100V1kWまでの電力をお申し込みの出展者は、コンセントにて電力を供給します。ただし、24時間送電を希望される出展者必要電力が1kW以内であっても、2kWにてお申し込みをお願いします。<br />
                            ※蛍光灯・高圧水銀灯の容量は、定格の1.5倍で計算をしてください。<br />
                            ※単相200V使用の場合は、備考欄に（単相200V）と明記してください。<br />
                            ※機器の場合は合計容量を記入し、備考欄にモーター容量などの明細を入力してください。<br />
                            ※馬力（HP）表示の機器は、1馬力＝1kW、VA表示の機器はWに換算して入力してください。<br />
                            ※始動電流の大きな機器は、備考欄に電流値、時間、希望開閉器容量などを入力してください。<br />
                            ※単相200V回路、24時間送電、切り替えスイッチ使用の場合には特に明記してください。
                        </Typography>

                        <Typography variant="h6" sx={{ mt: 4 }}>基本供給電力（無料）</Typography>
                        <Typography sx={{ mt: 4 }}>交流単相二線式100V 60Hz 500W</Typography>

                        <RadioGroup
                          row
                          value={comp5Data.ordi_elec ? "true" : "false"}
                          onChange={(e) =>
                            setComp5Data((prev) => ({
                              ...prev,
                              ordi_elec: e.target.value === "true",
                            }))
                          }
                        >
                          <FormControlLabel value="true" control={<Radio />} label="利用する" />
                          <FormControlLabel value="false" control={<Radio />} label="利用しない" />
                        </RadioGroup>
                        <Typography color='error'>
                            ※こちらを「希望しない」場合は、コンセントによる電力供給はありません。<br />
                            ※2小間以上のご出展の場合は、小間数に応じて基本電力の供給を行います。<br />
                            　（例：2小間＝1000W、4小間＝2000W）<br />
                            ※電力供給を申込した場合は、必ずブース平面図にてコンセント位置を記載ください。
                        </Typography>

                        {comp5Data.ordi_elec && (
                          <>
                          <Typography variant="h6" sx={{ mt: 4 }}>
                            追加電気容量 <span style={{ color: "red" }}>（有料）</span>
                          </Typography>

                          <FormGroup row>
                          <FormControlLabel
                          control={<Checkbox name="v100" checked={checked.v100} onChange={handleCheckboxChange} />}
                          label="100Vを希望する"
                          />
                          <FormControlLabel
                          control={<Checkbox name="v200" checked={checked.v200} onChange={handleCheckboxChange} />}
                          label="200Vを希望する"
                          />
                          </FormGroup>
                          {(checked.v100 || checked.v200) && (
                          <Typography sx={{ mt: 4 }}>終夜送電が必要な場合は以下のチェックボックスにチェックしてください。</Typography>
                          )}
                          <Grid container spacing={2}>
                            {checked.v100 && (
                            <Grid size={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={comp5Data.quantity_100v || false}
                                    onChange={(e) =>
                                      setComp5Data((prev) => ({
                                        ...prev,
                                        quantity_100v: e.target.checked,
                                      }))
                                    }
                                  />
                                }
                                label="100V終夜送電"
                              />
                            </Grid>
                            )}
                            {checked.v200 && (
                            <Grid size={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={comp5Data.quantity_200v || false}
                                    onChange={(e) =>
                                      setComp5Data((prev) => ({
                                        ...prev,
                                        quantity_200v: e.target.checked,
                                      }))
                                    }
                                  />
                                }
                                label="200V終夜送電"
                              />
                            </Grid>
                            )}
                          </Grid>

                        <Grid container spacing={2}>
                        {/* {checked.v100 && (
                        <Grid size={12} sm={4}>
                            <Typography sx={{fontWeight: 'bold'}}>➀100Vの必要容量</Typography>
                            <Typography sx={{color: 'red'}}>※100Vの➀または➁のいずれかをご入力ください。</Typography>
                            <TextField
                            type="number"
                            label="100V容量（W）"
                            value={comp5Data.quantity_100v}
                            onChange={handleValidatedChange(
                                "quantity_100v",
                                decimalValidator({ scale: 2, label: "100V容量" })
                            )}
                            disabled={comp5Data.details_100.some(r => r.quantity_100 > 0)}
                            error={!!errors.quantity_100v || !!submitErrors5.details_100}
                            helperText={errors.quantity_100v || submitErrors5.details_100}
                            slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                            />
                        </Grid>
                        )}
                        {checked.v200 && (
                        <Grid size={12} sm={4}>
                            <Typography sx={{fontWeight: 'bold'}}>➀200Vの必要容量</Typography>
                            <Typography sx={{color: 'red'}}>※200Vの➀または➁のいずれかをご入力ください。</Typography>
                            <TextField
                            type="number"
                            label="200V容量（W）"
                            value={comp5Data.quantity_200v}
                            onChange={handleValidatedChange(
                                "quantity_200v",
                                decimalValidator({ scale: 2, label: "200V容量" })
                            )}
                            disabled={comp5Data.details_200.some(r => r.quantity_200 > 0)}
                            error={!!errors.quantity_200v || !!submitErrors5.details_200}
                            helperText={errors.quantity_200v || submitErrors5.details_200}
                            slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                            />
                        </Grid>
                        )} */}
                        {/* {(checked.v100 || checked.v200) && (
                        <Grid size={12} sm={4}>
                            <Typography>総合計容量： {comp5Data.quantity_all} W</Typography>
                        </Grid>
                        )} */}
                        </Grid>

                        {checked.v100 && (
                        <>
                        <Typography sx={{ mt: 4, fontWeight: 'bold' }}>100Vの使用詳細<br />※使用される電気機器を全てご入力ください。</Typography>
                        {comp5Data.details_100.map((row, i) => (
                        <div key={i} className="mt-4">
                            <TextField
                            label="機器名"
                            value={row.device_100_name}
                            onChange={(e) =>
                                handleDetailChange("details_100", i, "device_100_name", e.target.value)
                            }
                            />
                            <TextField
                                label="容量(W)"
                                value={row.quantity_100}
                                onChange={handleDetailValidatedChange(
                                    "details_100",
                                    i,
                                    "quantity_100",
                                    decimalValidator({ scale: 2, label: "容量" })
                                )}
                                error={
                                    !!detailErrors.details_100?.[i]?.quantity_100 ||
                                    !!submitErrors5[`details_100_${i}_quantity_100`]
                                }
                                helperText={
                                    detailErrors.details_100?.[i]?.quantity_100 ||
                                    submitErrors5[`details_100_${i}_quantity_100`] ||
                                    ""
                                }
                                inputMode="decimal"
                            />
                            <TextField
                            label="数量"
                            value={row.number_100}
                            onChange={handleDetailValidatedChange(
                                "details_100",
                                i,
                                "number_100",
                                intValidator({ label: "数量" })
                            )}
                            error={
                                !!detailErrors.details_100?.[i]?.number_100 ||
                                !!submitErrors5[`details_100_${i}_number`]
                            }
                            helperText={
                                detailErrors.details_100?.[i]?.number_100 ||
                                submitErrors5[`details_100_${i}_number`] ||
                                ""
                            }
                            inputMode="numeric"
                            />
                            <TextField
                            label="合計"
                            value={row.total_100}
                            disabled
                            />
                            <TextField
                            label="備考"
                            value={row.ex_100}
                            onChange={(e) =>
                                handleDetailChange("details_100", i, "ex_100", e.target.value)
                            }
                            />
                            {/* 他の入力も同様 */}
                            <Button onClick={() => removeDetail("details_100", i)}>削除</Button>
                        </div>
                        ))}
                        <Typography variant="subtitle1" sx={{ mt: 2 }}>
                        合計（100V）：{
                            comp5Data.details_100.reduce((sum, row) => {
                            const q = Number(row.quantity_100) || 0;
                            const n = Number(row.number_100) || 0;
                            return sum + q * n;
                            }, 0)
                        } W
                        </Typography>
                        <Button variant="contained" onClick={() => addDetail("details_100")} sx={{mt: 2}}>電気機器を追加</Button>
                        </>
                        )}

                        {checked.v200 && ( 
                        <>
                        <Typography sx={{ mt: 4, fontWeight: 'bold' }}>200Vの使用詳細<br />※使用される電気機器を全てご入力ください。</Typography>
                        {comp5Data.details_200.map((row, i) => (
                        <div key={i} className='mt-4'>
                            <TextField
                            label="機器名"
                            value={row.device_200_name}
                            onChange={(e) =>
                                handleDetailChange("details_200", i, "device_200_name", e.target.value)
                            }
                            />
                            <TextField
                                label="容量(W)"
                                value={row.quantity_200}
                                onChange={handleDetailValidatedChange(
                                    "details_200",
                                    i,
                                    "quantity_200",
                                    decimalValidator({ scale: 2, label: "容量" })
                                )}
                                error={
                                    !!detailErrors.details_200?.[i]?.quantity_200 ||
                                    !!submitErrors5[`details_200_${i}_quantity_200`]
                                }
                                helperText={
                                    detailErrors.details_200?.[i]?.quantity_200 ||
                                    submitErrors5[`details_200_${i}_quantity_200`] ||
                                    ""
                                }
                                inputMode="decimal"
                            />
                            <TextField
                                label="数量"
                                value={row.number_200}
                                onChange={handleDetailValidatedChange(
                                    "details_200",
                                    i,
                                    "number_200",
                                    intValidator({ label: "数量" })
                                )}
                                error={
                                    !!detailErrors.details_200?.[i]?.number_200 ||
                                    !!submitErrors5[`details_200_${i}_number`]
                                }
                                helperText={
                                    detailErrors.details_200?.[i]?.number_200 ||
                                    submitErrors5[`details_200_${i}_number`] ||
                                    ""
                                }
                                inputMode="numeric"
                            />
                            <TextField
                            label="合計"
                            value={row.total_200}
                            disabled
                            />
                            <TextField
                            label="備考"
                            value={row.ex_200}
                            onChange={(e) =>
                                handleDetailChange("details_200", i, "ex_200", e.target.value)
                            }
                            />
                            {/* 他の入力も同様 */}
                            <Button onClick={() => removeDetail("details_200", i)}>削除</Button>
                        </div>
                        ))}
                        <Typography variant="subtitle1" sx={{ mt: 2 }}>
                        合計（200V）：{
                            comp5Data.details_200.reduce((sum, row) => {
                            const q = Number(row.quantity_200) || 0;
                            const n = Number(row.number_200) || 0;
                            return sum + q * n;
                            }, 0)
                        } W
                        </Typography>
                        <Button variant="contained"  onClick={() => addDetail("details_200")} sx={{mt: 2}}>電気機器を追加</Button>
                        </>
                        )}
                        </>
                        )}

                        <Typography variant="h6" sx={{ mt: 4 }}>備考欄</Typography>
                        <Typography color="error">※電気（電力）使用申込について補足事項がある場合はコチラにご入力ください。</Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            label="備考"
                            name="alfa_text"
                            value={comp5Data.alfa_text}
                            onChange={handleChange}
                        />
                    </Box>
                    )}
                </Box>
            </Container>
            <div style={{padding: '15px'}}></div>
            <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
              <Typography>
                【上記入力内容についてのお問い合わせ先】<br />
                SDGs 子ども・ユースフェア出展者事務局（中部経済新聞社 事業部内）<br />
                担当：佐野、三宅<br />
                TEL:052-561-5675<br />
                入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
                ※お急ぎの場合はお電話にてお問い合わせください。
              </Typography>
            </Box>
            {!isCorpModal &&(
            <Container sx={{textAlign: 'center'}}>
                <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                    提出する
                </Button>
            </Container>
            )}
        </Container>
      </Container>
      <Dialog open={noticeModalOpen} onClose={handleCloseNotice}>
        <DialogTitle>注意事項</DialogTitle>
        <DialogContent>
          <p>
            電気・電力申込を申請する場合は、電気引き出し位置及び備品設置位置を「ブース平面図」よりご提出ください。
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNotice} color="primary">
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
      {!isCorpModal &&(
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
      )}
      {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button
          variant="contained"
          onClick={handleCorrection}
          sx={{
            backgroundColor: "red",
            color: "white",
            "&:hover": {
              backgroundColor: "darkred",
            },
          }}
        >
          再提出
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          完了
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
  );
};

export default Comp5Sub;
